import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useLocation } from '../../common/RouterHooks';
import Header from '../../main/components/Header';
import Contact from './Contact';

const ContactLayout: React.FC = () => {
    const { t } = useTranslation();
    const { state } = useLocation();

    return (
        <React.Fragment>
            <div className={classNames(['grid-container', 'padding-bottom-4', 'service-inclusive', 'tyres'])}>
                <div className={classNames(['grid-x', 'grid-margin-x'])}>
                    <Header title={t(`tyre:header-contact`)} />
                    <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                        <Contact tyreList={state && (state as any).tyreList ? (state as any).tyreList : []} />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ContactLayout;
